/* TB homepage: tabs, quick add (real variant via Venue cart store -> /cart/add.js), color dots from the builder snapshot. */
import Cart from "cart-store";
import { loadBuilderData, swatchBg, hexFor, byHandle, siblings } from "./tb-hb-data.js";

function openCart(){
  const cart=document.querySelector('.modal--cart, .popup--cart-notification');
  if(cart && !cart.shown && typeof cart.open==='function') cart.open();
}
async function quickAdd(btn){
  if(btn.disabled) return;
  const id=Number(btn.dataset.variantId); if(!id) return;
  btn.disabled=true; btn.classList.add('is-busy');
  const label=btn.querySelector('span'); const prev=label?label.textContent:'';
  try{
    await Cart.add({id, quantity:1});
    btn.classList.remove('is-busy'); btn.classList.add('is-done'); if(label) label.textContent='Added';
    try{ await Cart.resetVariantsBeingAdded(); }catch(e){}
    openCart();
    setTimeout(()=>{btn.classList.remove('is-done'); if(label) label.textContent=prev; btn.disabled=false;},1800);
  }catch(e){
    btn.classList.remove('is-busy'); if(label) label.textContent='Unavailable'; console.warn('[tb] quick add failed',e);
    setTimeout(()=>{ if(label) label.textContent=prev; btn.disabled=false;},2200);
  }
}
document.addEventListener('click',e=>{const b=e.target.closest('[data-tb-quick-add]'); if(b){e.preventDefault(); quickAdd(b);}});

document.querySelectorAll('[data-tb-best]').forEach(root=>{
  const tabs=[...root.querySelectorAll('[role=tab]')];
  tabs.forEach(t=>t.addEventListener('click',()=>{
    tabs.forEach(x=>{const on=x===t;x.setAttribute('aria-selected',on);const p=document.getElementById(x.getAttribute('aria-controls'));if(p)p.hidden=!on;});
  }));
});

(async()=>{
  const cards=document.querySelectorAll('[data-tb-card]'); if(!cards.length) return;
  const D=await loadBuilderData(); if(!D) return;
  const H=byHandle(D);
  cards.forEach(card=>{
    const keys=H[card.dataset.handle]; if(!keys) return;
    const [patch,style,color]=keys[0].split('|');
    const sib=siblings(D,patch,style).filter(s=>s.a);
    sib.sort((a,b)=>(a.h===card.dataset.handle?-1:b.h===card.dataset.handle?1:0));
    const sw=card.querySelector('[data-tb-swatches]'); const sub=card.querySelector('[data-tb-sub]');
    if(sub && sib.length>1) sub.innerHTML=`${(sub.textContent||color).trim()} &middot; ${sib.length} colors in stock`;
    if(!sw) return;
    const max=5; sw.innerHTML='';
    sib.slice(0,max).forEach(s=>{const a=document.createElement('a');a.href='/products/'+s.h;a.title=s.color;a.setAttribute('aria-label',s.color);
      a.innerHTML=`<i style="background:${swatchBg(hexFor(D,style,s.color))}"></i>`;sw.append(a);});
    if(sib.length>max){const em=document.createElement('em');em.textContent='+'+(sib.length-max);sw.append(em);}
  });
})();
